"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.surveyResultFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.surveyResultFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    survey_id: 1,
    survey_name: 'Test Survey',
    survey_type: 'registration',
    site_id: 500,
    site_name: 'Test Site',
    organization_id: 530,
    organization_name: 'Test Org',
    persona_id: mocks_1.persona.id,
    order_id: 1,
    user_id: 1,
    status: 'Active',
    placed_at: mocks_1.dates.date2000,
    updated_at: mocks_1.dates.date2000,
    user: null,
    attachments: null,
    completed: true
});
